import React from 'react'
import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'
import ScheduleColumn from 'ui/schedule/ScheduleColumn'
import useActiveScheduleWeekday from 'support/hooks/use-active-schedule-weekday'
import ScheduleDayOverviewCard from 'widgets/shifts/themes/calendar/ScheduleDayOverviewCard'

function ScheduleDayOverviewColumn (props) {
  const weekDay = useValue('weekDay')

  const [activeScheduleWeekday] = useActiveScheduleWeekday()

  return (
    <ScheduleColumn bottomColumn highlight={weekDay === activeScheduleWeekday}>
      <ScheduleDayOverviewCard scheduleModel={props.scheduleModel} />
    </ScheduleColumn>
  )
}

export default observer(ScheduleDayOverviewColumn)
